import type { EventDataChanged } from '../../../domain/message';
import type { Commands } from '../../../messageHandler';
import DataExtractionService from '../../dataExtraction/DataExtractionService';

const handleIframeLoad = (commands: Commands): void => {
  commands.setHomePage();
};

const handleDataChange = (commands: Commands, event: EventDataChanged): void => {
  const { collectedDomains } = DataExtractionService.googleSheets.extractData(event.data);

  if (collectedDomains.length) {
    commands.setGoogleSheetsPage();
    commands.setCollectedDomains(collectedDomains);
  } else {
    commands.setHomePage();
  }
};

export const googleSheetsMessageHandler = {
  handleIframeLoad,
  handleDataChange,
};
